import { ofType } from "redux-observable";
import { guard } from "../../../guards/guard";
import { TypeActionBuildings } from "../actionBuildings";
import { checkBuildingPurchaseHasEnoughLevel } from "../checks/checkBuildingPurchaseHasEnoughLevel";
import { checkBuildingPurchaseHasEnoughResourcePremium } from "../checks/checkBuildingPurchaseHasEnoughResourcePremium";
import { checkBuildingPurchaseHasEnoughResourceStandard } from "../checks/checkBuildingPurchaseHasEnoughResourceStandard";
import { checkBuildingPurchaseHasEnoughWorker } from "../checks/checkBuildingPurchaseHasEnoughWorker";
import { checkBuildingPurchaseIsConstructionInProgress } from "../checks/checkBuildingPurchaseIsConstructionInProgress";
import { pathBuildingPurchaseCharacterHelpMissingLevel } from "../path/pathBuildingPurchaseCharacterHelpMissingLevel";
import { pathBuildingPurchaseCharacterHelpMissingWorker } from "../path/pathBuildingPurchaseCharacterHelpMissingWorker";
import { pathBuildingPurchaseNotEnoughResourcePremium } from "../path/pathBuildingPurchaseNotEnoughResourcePremium";
import { pathBuildingPurchaseNotEnoughResourceStandard } from "../path/pathBuildingPurchaseNotEnoughResourceStandard";
import { pathConstructionInProgress } from "../path/pathConstructionInProgress";
import { pathPurchaseBuildingInitiate } from "../path/pathPurchaseBuildingInitiate";
export var epicBuildingsPurchaseStart = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionBuildings.StartPurchase), guard(state$, deps, pathPurchaseBuildingInitiate)([
        checkBuildingPurchaseHasEnoughLevel(pathBuildingPurchaseCharacterHelpMissingLevel),
        checkBuildingPurchaseHasEnoughWorker(pathBuildingPurchaseCharacterHelpMissingWorker),
        checkBuildingPurchaseIsConstructionInProgress(pathConstructionInProgress),
        checkBuildingPurchaseHasEnoughResourcePremium(pathBuildingPurchaseNotEnoughResourcePremium),
        checkBuildingPurchaseHasEnoughResourceStandard(pathBuildingPurchaseNotEnoughResourceStandard),
    ]));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/epics/epicBuildingsPurchaseStart.ts
// module id = 2059
// module chunks = 3